<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :key="toolbarKey" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"
        :search="filters"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="CreateBy" label="申请人/部门" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.CreateBy || '-' }}</div>
            <div class="sub-cell-text">{{ scope.row.DepartmentName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="LeaveTypeName" label="请假类型" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.LeaveTypeName || '-' }}</div>
            <div v-if="scope.row.SickLeaveTypes" class="sub-cell-text">{{ scope.row.SickLeaveTypes }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="StartDate" label="请假时间" width="195">
          <template slot-scope="scope">
            <span class="nowrap-cell">{{ formatLeaveListTime(scope.row.StartDate) }}</span>
            <span class="sub-cell-text nowrap-cell">至 {{ formatLeaveListTime(scope.row.EndDate) }} · {{ scope.row.LeaveDay }}天</span>
          </template>
        </el-table-column>

        <el-table-column prop="Reason" label="请假原因" min-width="160" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="MediaFile" label="图片" width="100" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.MediaFile" :max="2" />
          </template>
        </el-table-column>

        <!-- <el-table-column prop="MediaFile" label="图片" align="center" header-align="center">
            <template slot-scope="scope">
              <div style="display: inline;">
                <span style="display: flex; align-items: center;">
                  <img v-for="(item, index) in showImage(scope.row.MediaFile).slice(0, 2)" :key="index"
                    v-oss-src="item" width="60px"
                    style="margin-right: 5px; cursor: pointer; display: inline-block;" lazy v-viewer />
                  <span v-if="showImage(scope.row.MediaFile).length > 2" style="display: inline-block;">...</span>
                </span>
              </div>
            </template>
          </el-table-column> -->

        <el-table-column prop="Status" label="状态/门禁" width="120" align="center">
          <template slot-scope="scope">
            <div class="status-stack">
              <el-tag size="small" :type="getStatusType(scope.row.Status)">{{ getStatusText(scope.row.Status) }}</el-tag>
              <el-tooltip :content="scope.row.TbSyncStatusMessage || '暂无说明'" placement="top">
                <el-tag
                  v-if="scope.row.TbSyncStatus && scope.row.TbSyncStatus !== 'NotApplicable'"
                  size="mini"
                  :type="getTbSyncStatusType(scope.row.TbSyncStatus)"
                  class="tb-sync-clickable"
                  @click="handleViewTbSync(scope.row)">
                  门禁 {{ getTbSyncStatusText(scope.row.TbSyncStatus) }}
                </el-tag>
                <span v-else class="tb-sync-empty">门禁 —</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="申请时间" width="190">
          <template slot-scope="scope">
            <span class="nowrap-cell">{{ formatDateTime(scope.row.CreateTime) }}</span>
          </template>
        </el-table-column>
        <!-- 审批流程操作列 -->
        <el-table-column label="操作" width="110" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleViewApprovalSteps(scope.row)">
              查看流程
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right"></el-pagination>
      </el-col>

    </section>

    <import-result-dialog
      :visible.sync="importResultVisible"
      :result="importResult"
    />

    <!-- 导入：选择文件 -->
    <el-dialog :visible.sync="leaveImportDialogVisible" width="860px" custom-class="person-import-dialog"
      :close-on-click-modal="false" append-to-body @closed="onLeaveImportDialogClosed">
      <div slot="title" class="pi-dialog-title">
        <span class="pi-dialog-title__icon"><i class="el-icon-date"></i></span>
        <div>
          <strong>批量导入请假记录</strong>
          <p>下载模板填写后上传，学校以顶部所选为准</p>
        </div>
      </div>
      <div class="pi-body">
        <div class="pi-steps">
          <div class="pi-step"><span class="pi-step__no">1</span><div><strong>下载模板</strong><em>按列填写请假信息</em></div></div>
          <i class="el-icon-arrow-right pi-step__arrow"></i>
          <div class="pi-step"><span class="pi-step__no">2</span><div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div></div>
          <i class="el-icon-arrow-right pi-step__arrow"></i>
          <div class="pi-step"><span class="pi-step__no">3</span><div><strong>核对导入</strong><em>预览后再确认写入</em></div></div>
        </div>
        <button type="button" class="pi-template-card" @click="downloadLeaveImportTemplate">
          <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
          <span class="pi-template-card__meta">
            <strong>请假批量导入模板.xlsx</strong>
            <em>含班级、学生、请假类型、起止时间等；无需填写学校</em>
          </span>
          <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
        </button>
        <el-upload :key="'leave-upload-' + leaveImportUploadKey" class="pi-upload" drag action="#"
          :auto-upload="false" :limit="1" :show-file-list="false" accept=".xlsx,.xls"
          :on-change="onLeaveImportFileChange" :on-remove="onLeaveImportFileRemove" :on-exceed="onLeaveImportExceed">
          <div v-if="leaveImportFileRaw" class="pi-upload__file">
            <i class="el-icon-success pi-upload__ok"></i>
            <div><strong>{{ leaveImportFileRaw.name }}</strong><em>已选择，点击「解析并预览」</em></div>
          </div>
          <div v-else class="pi-upload__empty">
            <i class="el-icon-upload2"></i><strong>点击选择或拖拽 Excel 到此处</strong><em>仅支持 .xlsx / .xls</em>
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="pi-footer">
        <el-button @click="leaveImportDialogVisible = false">关闭</el-button>
        <el-button type="primary" icon="el-icon-view" :disabled="!leaveImportFileRaw"
          :loading="leaveImportParsing" @click="parseLeaveImportFile">解析并预览</el-button>
      </div>
    </el-dialog>

    <!-- 门禁下发详情。普通请假主记录最多包含请假和返校两类下发记录。最后更新：2026-10-22 -->
    <el-dialog title="门禁下发详情" :visible.sync="tbSyncDialogVisible" width="820px">
      <el-table :data="tbSyncItems" border stripe size="mini">
        <el-table-column prop="name" label="下发类型" width="110" />
        <el-table-column prop="time" label="时间段" min-width="220" />
        <el-table-column label="状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getTbSyncStatusType(scope.row.status)">
              {{ getTbSyncStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tbId" label="天波ID" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.tbId > 0 ? scope.row.tbId : '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="message" label="说明" min-width="160" show-overflow-tooltip />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tbSyncDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 导入核对 -->
    <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
      custom-class="person-import-dialog" append-to-body
      :before-close="(done) => { this.backToLeaveImportSelect(); done(); }">
      <div slot="title" class="pi-dialog-title">
        <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
        <div><strong>请假导入核对</strong><p>共 {{ outputs.length }} 条，确认无误后写入系统</p></div>
      </div>
      <el-table :data="outputs" class="pi-preview-table" border stripe style="width: 100%" max-height="520">
        <el-table-column prop="DepartmentName" label="班级名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="UserId" label="学生ID" width="100" show-overflow-tooltip />
        <el-table-column prop="UserName" label="学生姓名" width="100" show-overflow-tooltip />
        <el-table-column prop="LeaveTypeName" label="请假类型" width="100" show-overflow-tooltip />
        <el-table-column prop="StartDate" label="开始时间" min-width="140" show-overflow-tooltip />
        <el-table-column prop="EndDate" label="结束时间" min-width="140" show-overflow-tooltip />
        <el-table-column prop="Reason" label="请假原因" min-width="140" show-overflow-tooltip />
        <el-table-column fixed="right" label="操作" align="center" width="90">
          <template slot-scope="scope">
            <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="pi-footer">
        <el-button @click="backToLeaveImportSelect">返回上一步</el-button>
        <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">确认导入</el-button>
      </div>
    </el-dialog>


    <!-- 审批流程对话框。最后修改：2026-10-19 -->
    <el-dialog title="审批流程" :visible.sync="approvalStepsDialogVisible" width="640px" custom-class="approval-flow-dialog">
      <!-- 审批进度 / 抄送与通知：统一面板样式。最后修改：2026-10-19 -->
      <div class="flow-panel">
        <div class="flow-panel-head">
          <div class="flow-panel-title">
            <i class="el-icon-s-check"></i>
            <span>审批进度</span>
            <span v-if="approvalCreateTime" class="flow-create-time">创建时间：{{ approvalCreateTime }}</span>
          </div>
          <span v-if="approvalSteps.length" class="flow-count">{{ approvalSteps.length }} 人</span>
        </div>

        <div v-if="approvalSteps.length > 0" class="approval-steps-grid">
          <div
            v-for="step in approvalSteps"
            :key="step.Id"
            class="approval-step-card"
            :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
            <div class="step-card-head">
              <div class="step-card-main">
                <span class="step-badge">步骤 {{ step.StepNumber }}</span>
                <span class="step-name">{{ step.ApproverName || '-' }}</span>
              </div>
              <el-tag size="mini" :type="getApprovalStepStatusType(step.Status)" effect="plain">
                {{ getApprovalStepStatusText(step.Status) }}
              </el-tag>
            </div>
            <div class="step-card-time">审批时间：{{ formatDateTime(step.ApprovedAt) }}</div>
            <div v-if="step.Comments" class="step-card-comment">审批意见：{{ step.Comments }}</div>
          </div>
        </div>
        <div v-else class="no-data no-data-compact">暂无审批流程记录</div>
      </div>

      <div class="flow-panel">
        <div class="flow-panel-head">
          <div class="flow-panel-title">
            <i class="el-icon-message"></i>
            <span>抄送与通知</span>
            <el-tag v-if="ccFromCurrentConfig" size="mini" type="warning" effect="plain">当前配置 · 仅供参考</el-tag>
            <el-tag v-else size="mini" type="success" effect="plain">提交快照</el-tag>
          </div>
          <span v-if="ccPersonList.length" class="flow-count">{{ ccPersonList.length }} 人</span>
        </div>

        <div class="cc-panel-block">
          <div class="cc-block-label">指定人员</div>
          <div v-if="ccPersonList.length" class="cc-people">
            <span v-for="(name, index) in ccPersonList" :key="index" class="cc-person-chip" :title="name">
              <i class="el-icon-user"></i>{{ name }}
            </span>
          </div>
          <div v-else class="cc-empty">未指定抄送人员</div>
        </div>

        <div class="cc-flags">
          <div class="cc-flag" :class="ccClassTeacher ? 'is-on' : 'is-off'">
            <span class="cc-flag-dot"></span>
            <div class="cc-flag-text">
              <div class="cc-flag-name">抄送班主任</div>
              <div class="cc-flag-val">{{ ccClassTeacher ? '已开启' : '未开启' }}</div>
            </div>
          </div>
          <div class="cc-flag" :class="notifyParent ? 'is-on' : 'is-off'">
            <span class="cc-flag-dot"></span>
            <div class="cc-flag-text">
              <div class="cc-flag-name">通知家长</div>
              <div class="cc-flag-val">{{ notifyParent ? '已开启' : '未开启' }}</div>
            </div>
          </div>
        </div>

        <div v-if="ccFromCurrentConfig" class="cc-note">
          无提交快照时，以上按学生当前匹配的流程配置展示，仅供参考
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalStepsDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <leave-status-check-dialog
      :visible.sync="statusCheckVisible"
      source="leave"
      :department-id="DepartmentId"
      @fixed="handleQuery"
    />

  </section>
</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getLeaveRequestByDepartment, exportLeaveRequestByDepartment, batchImportLeaveRequests, getLeaveTypeList, deleteLeaveRequests } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import LeaveStatusCheckDialog from './components/LeaveStatusCheckDialog.vue'
import ImportResultDialog from '../../components/ImportResultDialog'
import { normalizeImportBatchResponse } from '../../utils/importResultParser'
import { fetchStudentLiveTypesByDeptId, applyLiveTypeFilterOptions } from '../../utils/studentLiveType'
import { read, utils, writeFile } from 'xlsx'
import '../../style/person-import-dialog.css'

export default {
  components: { Toolbar, DepartmentPane, LeaveStatusCheckDialog, ImportResultDialog },
  data() {
    return {
      filters: {
      },
      toolbarKey: Date.now(),
      BaseApiUrl: BaseApiUrl, //网络前缀
      leaveTypeOptions: [],
      searchList: [
        {
          label: '申请人',
          key: 'name',
        },
        {
          label: '请假类型',
          key: 'leaveType',
          type: 'select',
          options: []
        },
        {
          label: '天数',
          key: 'maxLeaveDay',
        },
        {
          label: '学生类型',
          key: 'liveTypeId',
          type: 'select',
          options: [{
            label: '全部',
            value: ''
          }]
        },
        {
          label: '申请开始时间',
          key: 'applyStartDate',
          init: false,
          type: 'datetime'
        },
        {
          label: '申请结束时间',
          key: 'applyEndDate',
          init: false,
          type: 'datetime'
        },
        {
          label: '请假开始时间',
          key: 'leaveDate',
          init: false,
          type: 'datetime'
        },
        {
          label: '请假结束时间',
          key: 'leaveEndDate',
          init: false,
          type: 'datetime'
        },
        // 添加状态下拉框筛选器
        {
          label: '状态',
          key: 'status',
          type: 'select',
          init: true,
          options: [
            { label: '全部', value: '' },
            { label: '待审批', value: 'Pending' },
            { label: '审批中', value: 'InProgress' },
            { label: '已批准', value: 'Approved' },
            { label: '已拒绝', value: 'Rejected' },
            { label: '已取消', value: 'Cancel' }
          ]
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      isResouceShow: 0,
      DepartmentId: 0,
      // 审批流程相关
      approvalStepsDialogVisible: false, // 审批流程对话框显示状态
      approvalSteps: [],// 审批步骤数据
      tbSyncDialogVisible: false,
      tbSyncItems: [],
      ccPersonList: [],
      ccClassTeacher: false,
      notifyParent: true,
      ccFromCurrentConfig: false,
      //excel
      outputs: [],
      excelShow: false,
      leaveImportDialogVisible: false,
      leaveImportFileRaw: null,
      leaveImportParsing: false,
      leaveImportUploadKey: 0,
      leaveImportKeepFileOnClose: false,
      importResultVisible: false,
      importResult: null,
      exportLoading: false, // 导出加载状态
      multipleSelection: [], // 选中的多选框数据
      statusCheckVisible: false,
    };
  },
  computed: {
    // 取第一个审批节点的创建时间。最后修改：2026-10-19
    approvalCreateTime() {
      if (!this.approvalSteps || !this.approvalSteps.length) return '';
      const first = this.approvalSteps.reduce((min, step) => {
        if (!min) return step;
        return (step.StepNumber || 0) < (min.StepNumber || 0) ? step : min;
      }, null);
      if (!first || !first.CreateTime) return '';
      return this.formatDateTime(first.CreateTime);
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return dateTime;
      }
    },
    // 列表时间精确到分钟，避免合并后的请假时间出现第三行。最后更新：2026-10-22
    formatLeaveListTime(dateTime) {
      const value = this.formatDateTime(dateTime);
      return value && value.length >= 16 ? value.substring(0, 16) : value;
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return '-';
      try {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        return date;
      }
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-';
      try {
        // 处理 TimeSpan 格式
        if (typeof time === 'string' && time.includes(':')) {
          return time;
        }

        // 处理日期对象
        const date = new Date(time);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return time;
      }
    },

    // 获取请假状态类型
    getStatusType(status) {
      const typeMap = {
        'Pending': 'warning',       // 待审批
        'InProgress': 'info',       // 审批中
        'Approved': 'success',      // 已批准
        'Ended': 'success',         // 已结束
        'Rejected': 'danger',       // 已拒绝
        'Cancel': 'default'         // 已取消
      };
      return typeMap[status] || 'default';
    },

    // 获取请假状态文本
    getStatusText(status) {
      const statusMap = {
        'Pending': '待审批',
        'InProgress': '审批中',
        'Approved': '已批准',
        'Rejected': '已拒绝',
        'Cancel': '已取消',
        'Ended': '已结束'
      };
      return statusMap[status] || '未知状态';
    },

    // 获取门禁同步状态样式。最后更新：2026-10-22
    getTbSyncStatusType(status) {
      return {
        Pending: 'warning',
        Processing: 'info',
        Success: 'success',
        PartialFailed: 'warning',
        Failed: 'danger',
        Unknown: 'info',
        NotApplicable: 'info'
      }[status] || 'info';
    },

    // 获取门禁同步状态文本。最后更新：2026-10-22
    getTbSyncStatusText(status) {
      return {
        Pending: '待同步',
        Processing: '同步中',
        Success: '已下发',
        PartialFailed: '部分失败',
        Failed: '下发失败',
        Unknown: '—',
        NotApplicable: '—'
      }[status] || '—';
    },

    // 查看普通请假门禁下发明细。最后更新：2026-10-22
    handleViewTbSync(row) {
      const items = [{
        name: '请假',
        time: `${this.formatDateTime(row.StartDate)} 至 ${this.formatDateTime(row.EndDate)}`,
        status: row.TbSyncStatus,
        tbId: row.TbThirdPartId,
        message: row.TbSyncStatusMessage || ''
      }];
      const returnPeriod = row.ReturnSchoolPeriod;
      if (returnPeriod) {
        items.push({
          name: '返校',
          time: `${this.formatDate(returnPeriod.ReturnDate)} ${this.formatTime(returnPeriod.ReturnStartTime)} - ${this.formatTime(returnPeriod.ReturnEndTime)}`,
          status: returnPeriod.TbThirdPartId > 0 ? 'Success' : row.TbSyncStatus,
          tbId: returnPeriod.TbThirdPartId,
          message: returnPeriod.TbThirdPartId > 0 ? '返校记录已下发' : '返校记录尚无明确同步状态'
        });
      }
      this.tbSyncItems = items;
      this.tbSyncDialogVisible = true;
    },

    // 获取审批步骤状态类型
    getApprovalStepStatusType(status) {
      const typeMap = {
        'Pending': 'warning',       // 待审批
        'Approved': 'success',      // 已批准
        'Rejected': 'danger',       // 已拒绝
        'Cancel': 'default'         // 已取消
      };
      return typeMap[status] || 'default';
    },

    // 获取审批步骤状态文本
    getApprovalStepStatusText(status) {
      const statusMap = {
        'Pending': '待审批',
        'Approved': '已批准',
        'Rejected': '已拒绝',
        'Cancel': '已取消'
      };
      return statusMap[status] || '未知状态';
    },

    // 查看审批流程
    handleViewApprovalSteps(row) {
      // 从行数据中获取审批步骤
      this.approvalSteps = row.LeaveApprovalSteps || [];
      this.ccPersonList = this.parseCcPersonNames(row.CcPersonNames);
      this.ccClassTeacher = !!row.CcClassTeacher;
      this.notifyParent = row.NotifyParent !== false;
      this.ccFromCurrentConfig = !!row.CcFromCurrentConfig;
      // 显示对话框
      this.approvalStepsDialogVisible = true;
    },
    // 抄送姓名拆成列表。最后修改：2026-10-19
    parseCcPersonNames(val) {
      if (!val) return [];
      return String(val).split('|').map(s => s.trim()).filter(s => s);
    },

    async loadLiveTypeFilter(departmentId) {
      const types = await fetchStudentLiveTypesByDeptId(departmentId);
      applyLiveTypeFilterOptions(this.searchList, types);
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.Id;
      this.loadLiveTypeFilter(this.DepartmentId);
      // 获取请假类型
      getLeaveTypeList({ departmentId: this.DepartmentId }).then(res => {
        if (res.data && res.data.response) {
          this.leaveTypeOptions = res.data.response.map(item => ({
            label: item.Name,
            value: item.Id
          }));
          const leaveTypeSearch = this.searchList.find(item => item.key === 'leaveType');
          if (leaveTypeSearch) {
            leaveTypeSearch.type = 'select';
            leaveTypeSearch.options = [{ label: '全部', value: '' }, ...this.leaveTypeOptions];
          }
          this.filters = {}; // 重置过滤器
          this.toolbarKey = Date.now();
          this.handleQuery(); // 获取数据
        } else {
          this.handleQuery(); // 即使没有请假类型也要刷新列表
        }
      });
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      testapi();
      getLeaveRequestByDepartment(para).then(async (res) => {
        this.total = res.data.response.dataCount
        this.pageSize = res.data.response.PageSize
        const rows = res.data.response.data || []
        await this.prefetchListOssMedia(rows, 'MediaFile')
        this.users = rows
        this.listLoading = false
      });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          intPageSize: this.pageSize,
          departmentId: this.DepartmentId,
          ...this.filters,
        };

        var fileName = "请假申请记录";
        const response = await exportLeaveRequestByDepartment(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

    // 批量删除
    handleDelUsers() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要删除的请假申请！');
        return;
      }
      const ids = this.multipleSelection.map(item => item.Id).join(',');
      this.$confirm('确认要批量删除选中的请假申请吗？', '提示', { type: 'warning' })
        .then(() => {
          console.log('批量删除的请假申请IDs:', ids);
          this.listLoading = true;
          deleteLeaveRequests({ idStrs: ids }).then(res => {
            this.listLoading = false;
            if (res.data.success) {
              this.$message.success(res.data.msg || '批量删除成功');
              this.handleQuery();
            } else {
              this.$message.error(res.data.msg || '批量删除失败');
            }
          }).catch(() => {
            this.listLoading = false;
          });
        });
    },

    /** 打开请假状态异常检查弹窗 */
    handleLeaveStatusCheck() {
      this.statusCheckVisible = true;
    },

    // 导入
    ImportCensus() {
      this.resetLeaveImportDialog();
      this.leaveImportDialogVisible = true;
    },
    resetLeaveImportDialog() {
      this.leaveImportFileRaw = null;
      this.leaveImportParsing = false;
      this.leaveImportUploadKey += 1;
    },
    onLeaveImportDialogClosed() {
      if (this.leaveImportKeepFileOnClose) {
        this.leaveImportKeepFileOnClose = false;
        return;
      }
      this.resetLeaveImportDialog();
    },
    backToLeaveImportSelect() {
      this.excelShow = false;
      this.leaveImportDialogVisible = true;
    },
    onLeaveImportFileChange(file) {
      this.leaveImportFileRaw = file && file.raw ? file.raw : null;
    },
    onLeaveImportFileRemove() {
      this.leaveImportFileRaw = null;
    },
    onLeaveImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.leaveImportUploadKey += 1;
      this.$nextTick(() => { this.leaveImportFileRaw = nextFile; });
    },
    downloadLeaveImportTemplate() {
      const headers = ['班级名称', '学生ID', '学生姓名', '请假类型', '开始时间', '结束时间', '返校时间', '请假原因'];
      const sample = ['一年级1班', '', '张三', '事假', '2026-09-01 08:00:00', '2026-09-01 18:00:00', '', '家中有事'];
      const sheet = utils.aoa_to_sheet([headers, sample]);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, '请假导入');
      writeFile(book, '请假批量导入模板.xlsx');
    },
    parseLeaveImportFile() {
      if (!this.leaveImportFileRaw) {
        this.$message.warning('请先选择 Excel 文件');
        return;
      }
      const file = this.leaveImportFileRaw;
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$message.error('上传格式不正确，请上传 xls 或 xlsx 格式');
        return;
      }
      this.leaveImportParsing = true;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const workbook = read(ev.target.result, { type: 'binary' });
          const ws = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { raw: false, dateNF: 'yyyy-mm-dd hh:mm:ss' });
          this.outputs = this.reSetKey(ws);
          this.leaveImportParsing = false;
          this.leaveImportKeepFileOnClose = true;
          this.leaveImportDialogVisible = false;
          this.excelShow = true;
        } catch (e) {
          this.leaveImportParsing = false;
          this.$message.error('文件读取失败');
        }
      };
      fileReader.onerror = () => {
        this.leaveImportParsing = false;
        this.$message.error('文件读取失败');
      };
      fileReader.readAsBinaryString(file);
    },
    resolveActiveSchoolId() {
      const raw = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId');
      if (raw === null || raw === undefined || raw === '' || raw === '0') return null;
      return raw;
    },
    showImportResult(resData) {
      this.importResult = (resData && resData.response) || null;
      this.importResultVisible = true;
      const normalized = normalizeImportBatchResponse(resData || {});
      if (!normalized.items.length) {
        const text = normalized.summary || (resData && resData.msg) || '';
        if (text) this.$message.success(text);
      }
    },
    //删除错误行
    removeImport(e) {
      console.log(e['$index'])
      this.$confirm('确定要删除' + e.row.UserName + '的信息').then(() => {
        this.outputs.splice(e['$index'], 1)
      })
    },

    // 保存信息
    SavaImport() {
      const schoolDepartmentId = this.resolveActiveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      const loading = this.$loading({ lock: true, text: '导入中', background: 'rgba(0, 0, 0, 0.7)' });
      batchImportLeaveRequests({ schoolDepartmentId: schoolDepartmentId, items: this.outputs })
        .then((res) => {
          loading.close();
          if (res.data && res.data.success) {
            this.excelShow = false;
            this.showImportResult(res.data);
            this.handleQuery();
          } else {
            this.showImportResult(res.data || {});
            if (!this.importResult) {
              this.$message.error((res.data && res.data.msg) || '导入失败');
            }
          }
        })
        .catch(() => {
          loading.close();
          this.$message.error('导入失败');
        });
    },
    reSetKey(ws) {
      const temp = [];
      ws.forEach((item) => {
        temp.push({
          DepartmentName: item['班级名称'] || item['DepartmentName'] || '',
          UserId: item['学生ID'] || item['UserId'] || '',
          UserName: item['学生姓名'] || item['UserName'] || '',
          LeaveTypeName: item['请假类型'] || item['LeaveTypeName'] || '',
          StartDate: item['开始时间'] !== undefined ? String(item['开始时间']) : '',
          EndDate: item['结束时间'] !== undefined ? String(item['结束时间']) : '',
          ReturnSchoolTime: item['返校时间'] || item['ReturnSchoolTime'] || '',
          Reason: item['请假原因'] || item['Reason'] || '',
        });
      });
      return temp;
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some(item => item.Func === 'handleLeaveStatusCheck')) {
      this.buttonList.push({
        name: '检查',
        Func: 'handleLeaveStatusCheck',
        id: 993,
        IsHide: false,
        btnType: 'warning'
      });
    }
  },
};
</script>

<style scoped>
/* 门禁状态可查看下发详情。最后更新：2026-10-22 */
.tb-sync-clickable {
  cursor: pointer;
}

.status-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.tb-sync-empty {
  color: #a8abb2;
  font-size: 12px;
  line-height: 18px;
}

.nowrap-cell {
  white-space: nowrap;
}

.sub-cell-text {
  display: block;
  margin-top: 3px;
  color: #909399;
  font-size: 12px;
  line-height: 16px;
}

/* 审批步骤样式 */
.approval-step {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.step-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.step-number {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}

.step-approver {
  font-size: 14px;
  color: #666;
}

.step-content {
  padding-left: 20px;
}

.step-info {
  display: flex;
  gap: 30px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #999;
}

.step-comments {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
}

.no-data {
  text-align: center;
  color: #999;
  padding: 40px 0;
}


.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

/* 审批流程弹窗：统一面板。最后修改：2026-10-19 */
.flow-panel {
  margin-bottom: 12px;
  padding: 14px 16px 12px;
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #f4f7fb 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.flow-panel:last-of-type {
  margin-bottom: 0;
}

.flow-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #d7e2ef;
}

.flow-panel-title {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e3a5f;
}

.flow-panel-title i {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(37, 99, 235, 0.12);
  color: var(--btn-primary, #2563eb);
  font-size: 14px;
}

.flow-create-time {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.flow-count {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 999px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
}

.approval-steps-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 320px;
  overflow-y: auto;
}

.approval-step-card {
  flex: 0 0 calc(50% - 6px);
  box-sizing: border-box;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.approval-step-card.step-tone-0 {
  border-color: #bfdbfe;
  background: #f8fbff;
}

.approval-step-card.step-tone-0 .step-badge {
  background: #2563eb;
}

.approval-step-card.step-tone-1 {
  border-color: #ddd6fe;
  background: #faf8ff;
}

.approval-step-card.step-tone-1 .step-badge {
  background: #7c3aed;
}

.approval-step-card.step-tone-2 {
  border-color: #99f6e4;
  background: #f0fdfa;
}

.approval-step-card.step-tone-2 .step-badge {
  background: #0d9488;
}

.approval-step-card.step-tone-3 {
  border-color: #fed7aa;
  background: #fff7ed;
}

.approval-step-card.step-tone-3 .step-badge {
  background: #ea580c;
}

.step-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.step-card-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.step-badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.step-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.step-card-time {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.step-card-comment {
  margin-top: 6px;
  padding-left: 8px;
  border-left: 2px solid #93c5fd;
  max-height: 72px;
  overflow-y: auto;
  font-size: 12px;
  color: #1e3a5f;
  line-height: 1.45;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.step-card-comment::-webkit-scrollbar {
  width: 4px;
}

.step-card-comment::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.cc-panel-block {
  margin-bottom: 12px;
}

.cc-block-label {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.cc-people {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 180px;
  overflow-y: auto;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.cc-people::-webkit-scrollbar {
  width: 6px;
}

.cc-people::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.cc-person-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 160px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #c7d7f0;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cc-person-chip i {
  flex-shrink: 0;
  font-size: 12px;
  color: #3b82f6;
}

.cc-empty {
  font-size: 13px;
  color: #94a3b8;
}

.cc-flags {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.cc-flag {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #fff;
  transition: border-color 0.2s, background 0.2s;
}

.cc-flag.is-on {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.cc-flag.is-off {
  border-color: #e2e8f0;
  background: #f8fafc;
}

.cc-flag-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.cc-flag.is-on .cc-flag-dot {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
}

.cc-flag.is-off .cc-flag-dot {
  background: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.cc-flag-name {
  font-size: 12px;
  color: #64748b;
  line-height: 1.2;
}

.cc-flag-val {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}

.cc-flag.is-off .cc-flag-val {
  color: #64748b;
  font-weight: 500;
}

.cc-note {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #d7e2ef;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.5;
}

.no-data {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.no-data-compact {
  padding: 18px 0 12px;
}
</style>